import HTTPRequest from './httpRequest';
// import { API_URL } from '../../../../server/constants';

// default header for API calls
// const defaultHeaders = { 'Content-Type': 'application/json' };

// const defaultOptions = { credentials: 'include' };

export class GLIC_API_REQUEST extends HTTPRequest {
  UNAUTHORIZED_STATUS_CODE = 401;

  checkError = async response => {
    let body = null;
    // check for unauthorized status code
    if (response.status === this.UNAUTHORIZED_STATUS_CODE) {
      throw new Error('Unauthorized');
    } else if (!this.emptyContentStatusCodes.includes(response.status)) {
      body = await response.json();
      // if (!response.ok) {
      //   const message = response.statusText || 'Unexpected Error';
      //   const error = new Error(message);
      //   error.response = body;
      //   throw error;
      // }
    }
    return body;
  };

  parseJSON = body => (body && body.Data) || body;
}

// GLIC API util for calling ga-utils APIs using webseal as proxy
export const GLIC_API = new GLIC_API_REQUEST(); 

export const GLIC_API_V8 = new GLIC_API_REQUEST();
export const GLIC_WRAPPER_API = new GLIC_API_REQUEST();

export const GLIC_API_DOB = new GLIC_API_REQUEST();
